import { Menu, Button, Badge, HStack, Text, Portal } from '@chakra-ui/react';
import { FiPlus, FiChevronDown } from 'react-icons/fi'
import { ScriptElementType, ELEMENT_TYPE_LABELS, ELEMENT_TYPE_COLORS } from '../../types/script'

interface AddElementMenuProps {
  onAdd: (type: ScriptElementType) => void
}

const elementTypes = [
  ScriptElementType.Text,
  ScriptElementType.SurveyQuestion,
  ScriptElementType.TagAssignment,
  ScriptElementType.ConditionalBranch,
]

export function AddElementMenu({ onAdd }: AddElementMenuProps) {
  return (
    <Menu.Root>
      <Menu.Trigger asChild><Button size="sm" colorPalette="brand"><FiPlus />Add Element
                <FiChevronDown /></Button></Menu.Trigger>
      <Portal><Menu.Positioner><Menu.Content>
            {elementTypes.map((type) => (
              <Menu.Item key={type} onSelect={() => onAdd(type)} value={type}>
                <HStack gap={2}>
                  <Badge colorPalette={ELEMENT_TYPE_COLORS[type]} fontSize="xs">
                    {ELEMENT_TYPE_LABELS[type]}
                  </Badge>
                  <Text fontSize="sm">Add {ELEMENT_TYPE_LABELS[type]}</Text>
                </HStack>
              </Menu.Item>
            ))}
          </Menu.Content></Menu.Positioner></Portal>
    </Menu.Root>
  );
}
